export const filterRecommendationByTagFilterNotInOperator = (
  tagsFilterValues: Set<string>,
  resourceTagValue?: string,
) => {
  return !tagsFilterValues.has(resourceTagValue ?? "");
};
